import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-calendar-times text-muted me-5 fs-1" }, null, -1)
const _hoisted_3 = { class: "mb-9" }
const _hoisted_4 = { class: "d-flex align-items-center mb-2" }
const _hoisted_5 = { class: "fs-3 fw-bolder me-3" }
const _hoisted_6 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_7 = { class: "d-flex align-items-center mb-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 svg-icon-success me-5" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      fill: "#000000",
      cx: "12",
      cy: "12",
      r: "8"
    })
  ])
], -1)
const _hoisted_9 = { class: "fs-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder pe-2" }, "Starts", -1)
const _hoisted_11 = { class: "d-flex align-items-center mb-9" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 svg-icon-danger me-5" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      fill: "#000000",
      cx: "12",
      cy: "12",
      r: "8"
    })
  ])
], -1)
const _hoisted_13 = { class: "fs-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder pe-2" }, "Ends", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: _ctx.call.title,
    size: "mw-650px",
    "has-header": false,
    ref: "modal"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.call.title), 1),
            (_ctx.call.isFlexible)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Is Flexible"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", null, _toDisplayString(_ctx.getFriendlyDateTime(_ctx.call.start)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", null, _toDisplayString(_ctx.getFriendlyDateTime(_ctx.call.end)), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}